import {
    apiRegister
} from '../../common/api';

import {
    isNumber,
    isPlain
} from '../../common/utils';
import { ERR_REQ_CUP_ID, ERR_REQ_GAME_ID, ERR_REQ_KID, ERR_REP_ACTION } from '../../common/const';

/*
协议Id 
890
项目 
模块 
方式 
https 
命令（路径） 
/award/reality/actioninfo/
说明
实盘比赛获取当前用户做题题信息
请求参数
参数名称	参数类型	说明
cupId	int	
gameId	int	
kid	int	题id

*/

const actionInfo = apiRegister('action-info', {
    protoId: 886,
    path: '/award/reality/actioninfo/',
    checkQuery(Q) {
        if(!isNumber(Q.cupId)) {
            return ERR_REQ_CUP_ID
        }
        if(!isNumber(Q.gameId)) {
            return ERR_REQ_GAME_ID
        }
        if(!isNumber(Q.kid)) {
            return ERR_REQ_KID
        }
        return 0
    },
    checkResult(R) {
        const {
            actionInfo
        } = R
        if (!isPlain(actionInfo) || !isNumber(actionInfo.gameId)) {
            return 886021 // 数据格式非法
        }
        return 0
    },
    formatResult(R) {
        const {
            actionInfo
        } = R
        return {
            actionInfo
        }
    }
})

export const loadActionInfo = actionInfo.send


/*
协议Id 
892
项目 
模块 
方式 
https 
命令（路径） 
/award/reality/actiongame/
说明
实盘比赛做题
请求参数
参数名称	参数类型	说明
gameId	int	
cupId	int	
kid	int	题id
predictValue	float	预测涨跌幅

*/

const actionGame = apiRegister('action-game', {
    protoId: 892,
    path: '/award/reality/actiongame/',
    checkQuery(Q) {
        if(!isNumber(Q.cupId)) {
            return ERR_REQ_CUP_ID
        }
        if(!isNumber(Q.gameId)) {
            return ERR_REQ_GAME_ID
        }
        if(!isNumber(Q.kid)) {
            return ERR_REQ_KID
        }
        return 0
    },
    checkResult(R) {
        const {
            actionId
        } = R
        if (!isNumber(actionId)) {
            return  ERR_REP_ACTION // 数据格式非法
        }
        return 0
    },
    formatResult(R) {
        return R
    }
})

export const gameActionSubmit = actionGame.send
